export const TRANSLATIONS_PT_HOME_ACTIONS_AND_OVERVIEW = {
  "home.title": "Sistema de Geração Aumentada por Recuperação",
  "home.lead":
    "Melhore as respostas dos modelos de linguagem com informações contextuais dos seus documentos.",
  "home.description":
    "Envie documentos, faça consultas e obtenha respostas precisas baseadas nas suas próprias informações.",
  "home.upload_btn": "Enviar Documentos",
  "home.query_btn": "Fazer Consulta",
  "home.feature_processing_title": "Processamento de Documentos",
  "home.feature_processing_desc":
    "Extraia texto de documentos PDF, Word e TXT armazenados em S3 ou enviados diretamente.",
  "home.feature_embeddings_title": "Embeddings e Vetorização",
  "home.feature_embeddings_desc":
    "Converta texto em vetores usando modelos avançados de embeddings para busca semântica.",
  "home.feature_generation_title": "Geração de Respostas",
  "home.feature_generation_desc":
    "Obtenha respostas precisas baseadas nos seus documentos usando modelos de linguagem avançados.",
  "home.general.loading": "Carregando telemetria...",
  "home.general.retry": "Tentar novamente",
  "home.general.retryAfter": "Tentando novamente em",
  "home.general.actionUnavailableTitle": "Ação indisponível",
  "home.general.actionUnavailableMessage": "Não temos informações suficientes para concluir esta ação.",
  "home.pagination.previous": "Anterior",
  "home.pagination.next": "Próxima",
  "home.shared.aiBadge": "Sinal gerado por IA",
  "home.shared.detectedBadge": "Detectado automaticamente",
  "home.shared.prioritizedBadge": "Priorizado pela IA",
  "home.shared.recommendationBadge": "Próximo passo recomendado",
  "home.reasonCode.due_soon": "Vence em breve",
  "home.reasonCode.overdue": "Vencido",
  "home.reasonCode.high_priority": "Alta prioridade",
  "home.reasonCode.compliance_required": "Conformidade requerida",
  "home.reasonCode.needs_review": "Precisa de revisão",
  "home.reasonCode.pending_review": "Revisão pendente",
  "home.decisionStates.act_now": "Agir agora",
  "home.decisionStates.act_soon": "Agir em breve",
  "home.decisionStates.act_without_rush": "Pode esperar",
  "home.decisionStates.waiting": "Ação agendada",
  "home.decisionStates.blocked": "Aguardando informação",
  "home.decisionStates.in_review": "Em revisão",
  "home.decisionStates.dismissed": "Descartada",
  "home.decisionStates.safe_to_ignore": "Seguro ignorar",
  "home.decisionStates.completed": "Resolvida",
  "home.attention.sectionTitle": "Requer atenção",
  "home.attention.followUpTitle": "Acompanhamento",
  "home.attention.allClearTitle": "Tudo em ordem",
  "home.attention.allClearCopy": "Nenhuma decisão requer sua atenção no momento.",
  "home.decisionDisplay.priority.critical.label": "Crítica",
  "home.decisionDisplay.priority.critical.copy": "Está vencida ou pode gerar impacto operacional.",
  "home.decisionDisplay.priority.high.label": "Alta",
  "home.decisionDisplay.priority.high.copy": "A data está próxima e precisa de revisão.",
  "home.decisionDisplay.priority.medium.label": "Média",
  "home.decisionDisplay.priority.medium.copy": "Convém revisá-la em breve para evitar bloqueios ou atrasos.",
  "home.decisionDisplay.priority.low.label": "Baixa",
  "home.decisionDisplay.priority.low.copy": "Pode permanecer em acompanhamento por enquanto.",
  "home.decisionDisplay.risk.critical.label": "Risco crítico",
  "home.decisionDisplay.risk.critical.copy": "Pode interromper uma operação importante ou gerar descumprimento imediato.",
  "home.decisionDisplay.risk.high.label": "Risco alto",
  "home.decisionDisplay.risk.high.copy": "Pode afetar pagamentos, conformidade ou continuidade operacional.",
  "home.decisionDisplay.risk.medium.label": "Risco médio",
  "home.decisionDisplay.risk.medium.copy": "Pode gerar atrasos, retrabalho ou acompanhamento adicional.",
  "home.decisionDisplay.risk.low.label": "Risco baixo",
  "home.decisionDisplay.risk.low.copy": "O impacto operacional é limitado se for revisado a tempo.",
  "home.decisionDisplay.risk.none.label": "Risco a confirmar",
  "home.decisionDisplay.risk.none.copy": "Ainda não há contexto suficiente para qualificar o risco.",
  "home.decisionDisplay.confidence.high.label": "Alta confiança",
  "home.decisionDisplay.confidence.high.copy": "A recomendação é consistente com a evidência disponível.",
  "home.decisionDisplay.confidence.medium.label": "Confiança média",
  "home.decisionDisplay.confidence.medium.copy": "Convém revisar a evidência-chave antes de confirmar.",
  "home.decisionDisplay.confidence.low.label": "Baixa confiança",
  "home.decisionDisplay.confidence.low.copy": "Revise a evidência antes de agir.",
  "home.decisionSummary.eyebrow": "Estados",
  "home.decisionSummary.title": "Resumo de decisões",
  "home.decisionList.eyebrow": "Inbox",
  "home.decisionList.title": "Lista compacta de decisões",
  "home.decisionList.filteredTitle": "Decisões filtradas",
  "home.decisionList.empty": "Ainda não há decisões para mostrar.",
  "home.decisionList.emptyFiltered": "Não há decisões neste estado.",
  "home.viewMode.current": "Visão atual",
  "home.viewMode.calendar": "Calendário",
  "home.decisionActionForm.title": "Dados necessários",
  "home.decisionActionForm.selectPlaceholder": "Selecione uma opção",
  "home.decisionActionForm.required": "Preencha este campo para continuar.",
  "home.decisionActionForm.confirmExecution": "Confirmo que esta ação operacional deve ser executada.",
  "home.decisionActionForm.confirmRequired": "Confirme a ação antes de continuar.",
  "home.decisionActionForm.submit": "Executar ação",
  "home.decisionActionForm.cancel": "Cancelar",
  "home.decisionActionUx.blockedCopy": "Esta decisão importa agora, mas não pode ser concluída até que o bloqueio seja resolvido.",
  "home.decisionActionUx.blockedReason": "Resolva o bloqueio antes de executar a ação final.",
  "home.decisionActionUx.blockedTitle": "Urgente, mas bloqueada",
  "home.decisionActionUx.catalogCopy": "A fonte da decisão não está estável o suficiente para executar a ação final.",
  "home.decisionActionUx.catalogReason": "A recomendação foi degradada e requer revisão manual.",
  "home.decisionActionUx.catalogTitle": "A recomendação precisa de validação",
  "home.decisionActionUx.completeMissingInfo": "Revisar informações faltantes",
  "home.decisionActionUx.completedCopy": "Não há ação pendente para esta decisão.",
  "home.decisionActionUx.completedReason": "Esta decisão já foi resolvida.",
  "home.decisionActionUx.completedTitle": "Decisão resolvida",
  "home.decisionActionUx.confirmRequiredData": "Confirmar dados obrigatórios",
  "home.decisionActionUx.disabledCopy": "Esta decisão precisa de revisão antes de reativar a ação principal.",
  "home.decisionActionUx.disabledTitle": "A ação não está disponível",
  "home.decisionActionUx.lowConfidenceCopy": "A decisão não deve ser executada até que as evidências e a confiança sejam revisadas.",
  "home.decisionActionUx.lowConfidenceReason": "A confiança é baixa demais para executar a ação final.",
  "home.decisionActionUx.lowConfidenceTitle": "Esta recomendação precisa de revisão",
  "home.decisionActionUx.missingInfoCopy": "Revise as informações faltantes neste painel e complete o dado no documento ou sistema de origem antes de tentar a ação novamente.",
  "home.decisionActionUx.missingInfoReason": "A ação final permanece bloqueada até que esse dado exista na origem.",
  "home.decisionActionUx.missingInfoTitle": "Falta informação obrigatória",
  "home.decisionActionUx.noActionCopy": "Ainda não há ação confirmada para esta decisão.",
  "home.decisionActionUx.noActionTitle": "Sem ação confirmada",
  "home.decisionActionUx.readyCopy": "Esta decisão está pronta para a próxima ação.",
  "home.decisionActionUx.readyTitle": "Você pode agir agora",
  "home.decisionActionUx.resolveBlock": "Ver bloqueio",
  "home.decisionActionUx.reviewEvidence": "Revisar evidências",
  "home.decisionActionUx.reviewRecommendation": "Revisar recomendação",
  "home.decisionActionUx.reviewRequirements": "Revisar requisitos",
  "home.decisionActionUx.safeToIgnoreCopy": "Você pode manter esta decisão em observação sem intervir.",
  "home.decisionActionUx.safeToIgnoreReason": "Esta decisão pode permanecer em monitoramento sem ação imediata.",
  "home.decisionActionUx.safeToIgnoreTitle": "Nenhuma ação necessária agora",
  "home.decisionActionUx.waitingCopy": "Esta decisão depende de um sinal externo ou de uma atualização pendente.",
  "home.decisionActionUx.waitingLabel": "Aguardar atualização",
  "home.decisionActionUx.waitingReason": "O Home IA ainda aguarda a condição que habilita esta ação.",
  "home.decisionActionUx.waitingTitle": "Você ainda não pode agir",
};
